import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai'
import { theme } from '../builderUtils/theme'
import {
  Question,
  Answer,
  ImageContainer,
  QuestionRow,
  AnswerFirstRow,
  Border,
  ALink,
} from './styles'

export default function LPFAQItems({ question, answer, text, link, punctuation, placement }) {
  const [showAnswer, setShowAnswer] = useState(false)

  return (
    <div>
      {showAnswer ? (
        <div>
          <AnswerFirstRow
            role="button"
            onClick={() => setShowAnswer(false)}
            onKeyDown={() => setShowAnswer(false)}
            tabIndex={0}
          >
            <Question>{question}</Question>
            <ImageContainer>
              <AiOutlineMinus color={theme.coral} />
            </ImageContainer>
          </AnswerFirstRow>
          <Answer display="block">
            {answer.split('\n').map((a, i) => (
              <span key={`x${i}`}>
                {a} {` `}
                {(placement === i || !placement) && (
                  <>
                    <ALink href={link} target="_blank" rel="noopener noreferrer">
                      <b>{text}</b>
                    </ALink>
                    {punctuation}
                  </>
                )}
              </span>
            ))}
          </Answer>
          <Border />
        </div>
      ) : (
        <div>
          <QuestionRow
            role="button"
            onClick={() => setShowAnswer(true)}
            onKeyDown={() => setShowAnswer(true)}
            tabIndex={0}
          >
            <Question>{question}</Question>
            <ImageContainer>
              <AiOutlinePlus color={theme.coral} />
            </ImageContainer>
          </QuestionRow>
          <Border />
        </div>
      )}
    </div>
  )
}

LPFAQItems.propTypes = {
  question: PropTypes.any,
  answer: PropTypes.any,
  text: PropTypes.string,
  link: PropTypes.string,
  punctuation: PropTypes.string,
  placement: PropTypes.number,
}
